<!--Header-->
<app-landingpage-header-child [disableLogin]="true"></app-landingpage-header-child>
<!-- End Header-->

<!-- Content -->
<div id="wrapper">
  <div class="card-header-kyc font-weight-bold text-primary text-center d-block w-100">
    {{'kyc.identify_account' | translate}}</div>
  <div class="card-sub text-center">(*{{title}})</div>
  <div class="col-md-12 pr-0 notify-card mb-2" *ngIf="customer.identifyStatus && customer.identifyStatus == 3">
    <div class="card boxshadow-card" style="border-radius: 15px;">
      <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">
        <div class="d-flex">
          <div>
            <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>
          </div>
          <div class="flex-grow-3 pl-2">
            <span>{{'breadcrumbs.customer_reject_reason' | translate}} {{customer.identifyRejectReason}}</span>
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <mat-card>
    <mat-card-content>
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <!-- Thông tin doanh nghiệp -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.customer_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row" #focus tabindex="-1">
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="!isNotAttestedUser && customer.adminUser">{{'form.username' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="!isNotAttestedUser && customer.adminUser">{{customer.adminUser}}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="!isNotAttestedUser && customer.primaryEmail">{{'form.primary_email' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="!isNotAttestedUser && customer.primaryEmail">{{customer.primaryEmail}}</div>
          
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.name">{{'search_form.custommer_name' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.name">{{customer.name}}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.customer_type' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{getEnterpriseTypeOptions(customerType)}}</div>
          
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="(customer.customerType == personalId || customer.customerType == null) && customer.birthdayDisplay">{{'form.birthday' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="(customer.customerType == personalId || customer.customerType == null) && customer.birthdayDisplay">{{customer.birthdayDisplay}}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="(customer.customerType == personalId || customer.customerType == null) && customer.sex != null">{{'form.sex' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4" [ngSwitch]="customer.sex" *ngIf="(customer.customerType == personalId || customer.customerType == null) && customer.sex != null">
              <span *ngSwitchCase="false" class="col-form-label font-weight-bold d-flex">{{'form.female' | translate}}</span>
              <span *ngSwitchCase="true" class="col-form-label font-weight-bold d-flex">{{'form.male' | translate}}</span>
            </div>
          
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.customerType != personalId ? getEnterpriseTypeOptions(certificate) : getEnterpriseTypeOptions(representativeCertificateName)">{{'form.type_certification' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.customerType != personalId ? getEnterpriseTypeOptions(certificate) : getEnterpriseTypeOptions(representativeCertificateName)">{{customer.customerType != personalId ?
              getEnterpriseTypeOptions(certificate) : getEnterpriseTypeOptions(representativeCertificateName)}}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.certificateNo && !hiddenCerrtificateNo(customer.certificateNo)">{{'form.gpkd' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.certificateNo && !hiddenCerrtificateNo(customer.certificateNo)">{{customer.certificateNo}}</div>
          
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.issuedDateDisplay">{{'form.issued_date' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.issuedDateDisplay">{{customer.issuedDateDisplay}}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.issuedAt">{{'form.issued_by' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.issuedAt">{{customer.issuedAt}}</div>
          
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right"
              *ngIf="customer.customerType != personalId && customer.customerType != null">{{'form.tax_code' |
              translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold"
              *ngIf="customer.customerType != personalId && customer.customerType != null">{{customer.taxCode}}</div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel expanded="true" *ngIf="customer.customerType != personalId && customer.customerType != null">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.representative_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class=" row">
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.representative">{{'form.full_name' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.representative">{{customer.representative}}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.position">{{'form.position' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.position">{{customer.position}}</div>
          
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.birthdayDisplay">{{'form.birthday' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.birthdayDisplay">{{customer.birthdayDisplay}}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.sex != null">{{'form.sex' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4" [ngSwitch]="customer.sex"  *ngIf="customer.sex != null">
              <span class="col-form-label font-weight-bold" *ngSwitchCase="0">{{'form.female' | translate}}</span>
              <span class="col-form-label font-weight-bold" *ngSwitchCase="1">{{'form.male' | translate}}</span>
            </div>
          
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="getEnterpriseTypeOptions(representativeCertificateName)">{{'form.type_certification' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="getEnterpriseTypeOptions(representativeCertificateName)">
              {{getEnterpriseTypeOptions(representativeCertificateName)}}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.representativeCertificateNo">{{'form.gpkd' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.representativeCertificateNo">{{customer.representativeCertificateNo}}</div>
          
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.representativeIssuedDateDisplay">{{'form.issued_date' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.representativeIssuedDateDisplay">{{customer.representativeIssuedDateDisplay}}
            </div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.representativeIssuedAt">{{'form.issued_by' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.representativeIssuedAt">{{customer.representativeIssuedAt}}</div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.address' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class=" row">
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="addresses.cityName">{{'form.city' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="addresses.cityName">{{ addresses.cityName }}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="addresses.districtName">{{'form.district' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="addresses.districtName">{{ addresses.districtName }}</div>
          
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="addresses.wardName">{{'form.ward' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="addresses.wardName">{{ addresses.wardName }}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.address">{{'form.address' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.address">{{customer.address}}</div>
          
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.email">{{'headertable.email' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.email">{{customer.email}}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.phone">{{'search_form.phone' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.phone">{{customer.phone}}</div>
          
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.fax">{{'form.fax' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.fax">{{customer.fax}}</div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel expanded="true" *ngIf="customer.accountNumber || customer.accountName || customer.bankName || customer.bankBranch">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.pay_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.accountNumber">{{'form.accnumber' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.accountNumber">{{customer.accountNumber}}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.accountName">{{'form.accountName' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.accountName">{{customer.accountName}}</div>
          
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.bankName">{{'form.bank' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.bankName">{{customer.bankName}}</div>
            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="customer.bankBranch">{{'search_form.branch' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold" *ngIf="customer.bankBranch">{{customer.bankBranch}}</div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel expanded="true" *ngIf="customer.attachments?.length">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.attach' | translate}}
              <mat-label *ngIf="!customer.attachments?.length">&nbsp;{{'title.no_attachment' | translate}}</mat-label>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-upload-multi-file [isViewDetail]="true" [isCustomer]="true" [arrAttachments]="this.customer.attachments">
          </app-upload-multi-file>
        </mat-expansion-panel>

        <!-- Hồ sơ khách hàng -->
        <mat-expansion-panel expanded="true" *ngIf="!isNotAttestedUser">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.customer_information' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-kyc-customer-infor [isEnoughImage]="isEnoughImage" [listImageResponse]="customer.attachmentImages"  [readonly]="readonly" [hasNote]="hasNote"></app-kyc-customer-infor>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>

    <div *ngIf="!isNotAttestedUser" class="rule-header font-weight-bold d-block w-100 mt-5">{{'form.rule' | translate}}</div>
    <div *ngIf="!isNotAttestedUser" class="rule-sub mb-2">{{'kyc.rule_title' | translate}}</div>

    <ng-container *ngIf="pdfSrc != '' && !isNotAttestedUser">
      <ngx-extended-pdf-viewer [textLayer]="true" [src]="pdfSrc"
                               [(zoom)]="zoomLevel" [(page)]="pageCurrent"
                               [showToolbar]="true" useBrowserLocale="true" height="80vh" [handTool]="false" [enablePrint]="false"
                               [showDownloadButton]="false" [sidebarVisible]="true" [showRotateButton]="false"
                               [showOpenFileButton]="false" [showBookmarkButton]="false" [showPropertiesButton]="true"
                               [showUnverifiedSignatures]="true" [theme]="'dark'" [language]="language"
                               [zoomLevels]="[0.5,1,1.25, 1.5, 2, 3, 4]" [showSidebarButton]="isShowSidebarButton">
      </ngx-extended-pdf-viewer>
    </ng-container>

    <!-- Tôi đồng ý với điều khoản và chấp nhận -->
    <div class="row pt-4" *ngIf='!isNotAttestedUser'>
      <div class="col-12">
        <mat-checkbox [disabled]="!isNotAttestedUser && (!customer.attachmentImages || customer.attachmentImages.length != 3)" [(ngModel)]="checkAgree" [ngModelOptions]="{standalone: true}" color="primary">
        <span style="font-size:14px;" class="rule-link mat-stroked-button mat-primary p-0">{{'kyc.rule' | translate}}</span>
        </mat-checkbox>
      </div>
    </div>

    <mat-card-actions class="btn-group text-center mat-card-actions ng-tns-c1-0 pt-3 pb-5 d-flex justify-content-center" *ngIf="!(customer.identifyStatus && customer.identifyStatus == 3)">
      <!-- <button mat-stroked-button class="mr-3 mat-stroked-button mat-primary" (click)="onBackClick()">
        <mat-icon class="mr-0" color="primary">arrow_back</mat-icon>
        {{ 'button.back' | translate }}
      </button> -->
      <button (click)="refuseIdentify()" mat-stroked-button color="primary" class="mr-3 mat-stroked-button mat-primary">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'enterprise_contract.buttons.reject' | translate}}
      </button>
      <button (click)="otpIdentify()" mat-raised-button color="primary" class="mr-3 mat-raised-button mat-primary" [disabled]="!checkAgree">
        <mat-icon class="mr-0">check</mat-icon>
        {{'button.confirm_otp' | translate}}
      </button>
      <button (click)="verifyCheck()" mat-raised-button color="primary" class="mr-3 mat-raised-button mat-primary" [disabled]="!checkAgree">
        <mat-icon class="mr-0">done_all</mat-icon>
        {{'button.confirm_certificate' | translate}}
      </button>
    </mat-card-actions>

  </mat-card>

</div>

<!-- Footer -->
<app-landingpage-footer></app-landingpage-footer>
<!-- End of Footer -->
